import React from 'react'
import styled from 'styled-components'

import { StyledFunctionComponent } from '../../../types'

const SaveCreditCard = styled.span`
  font-weight: 500;
  white-space: nowrap;
`

const EmptyCreditCards: StyledFunctionComponent = ({ className }) => (
  <div className={className}>
    No credit cards saved yet. Save time placing your next order by selecting{' '}
    <SaveCreditCard>SAVE CREDIT CARD</SaveCreditCard> during checkout.
  </div>
)

const StyledEmptyCreditCards = styled(EmptyCreditCards)({
  lineHeight: '30px',
  textAlign: 'center',
})

export default StyledEmptyCreditCards
